// extracted by mini-css-extract-plugin
export default {"wrapper":"Newsletter_wrapper__uA9g6","message":"Newsletter_message__5PBGX","form":"Newsletter_form__YU3ml","input":"Newsletter_input__+Un6I","submit":"Newsletter_submit__23yCd"};